import { render, staticRenderFns } from "./detailSecond.vue?vue&type=template&id=4939ed38&scoped=true"
import script from "./detailSecond.vue?vue&type=script&lang=js"
export * from "./detailSecond.vue?vue&type=script&lang=js"
import style0 from "./detailSecond.vue?vue&type=style&index=0&id=4939ed38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939ed38",
  null
  
)

export default component.exports